import classNames from 'classnames/bind';
import TextArea from 'mcs-toolkit/components/TextArea';
import React from 'react';
import { TextAreaProps } from 'semantic-ui-react';

import { BasicField, BasicFieldProps } from './_BasicField';
import styles from './FieldTextArea.css';

const css = classNames.bind(styles);

export type FieldTextAreaProps = TextAreaProps &
    Omit<BasicFieldProps, 'control'> & {
        inputLike?: boolean;
    };
export const FieldTextArea = ({
    className,
    label,
    name,
    onChange,
    inputLike,
    dataTest,
    ...otherInputProps
}: FieldTextAreaProps) => {
    return (
        <BasicField
            data-test={dataTest}
            label={label}
            name={name}
            onChange={onChange}
            className={css(className, { inputLike })}
            control={TextArea}
            rows={inputLike ? 1 : undefined}
            {...otherInputProps}
        />
    );
};
